import {
	Component,
	Input,
	ContentChildren,
	QueryList,
	AfterContentInit, OnInit
} from '@angular/core';
import { PanelComponent } from './panel.component';

export enum COLLAPSE_MODE {
	FLAT = 'flat',
	COLLAPSE = 'collapse',
	FREE = 'free'
}

@Component({
	selector: 'cv-collapse',
	templateUrl: './collapse.component.html',
	styleUrls: ['./collapse.component.scss']
})
export class CollapseComponent implements AfterContentInit, OnInit {
	/**
	 * @Public global opcion for the behavior of the component.
	 * *could be collapse or flat.
	 * *collapse: keep just one panel open whether one panel is opnen.
	 * *flat: keeps all the panels open whenever or not one o mutiples panel are open.
	 */
	@Input() collapseMode: COLLAPSE_MODE = COLLAPSE_MODE.FLAT;
	@ContentChildren(PanelComponent) panels: QueryList<PanelComponent>;

	ngOnInit() {
		if (!Object.values(COLLAPSE_MODE).includes(this.collapseMode)) {
			this.collapseMode = COLLAPSE_MODE.COLLAPSE;
		}
	}

	ngAfterContentInit(): void {
		this.panels.forEach((p) => {
			if (this.collapseMode === COLLAPSE_MODE.FLAT) {
				p.active = true;
			} else if (this.collapseMode === COLLAPSE_MODE.COLLAPSE) {
				p.active = !!p.active;
			} else if (this.collapseMode === COLLAPSE_MODE.FREE) {
				p.active = p.defaultOpen;
			}
			p.toggle.subscribe(() => this.setActivePanel(p));
		});
	}

	/**
	 * setActivePanel
	 * * function that receive the panel object when the toggle event has been triggered.
	 */
	setActivePanel(panel: PanelComponent): void {
		if (this.collapseMode === 'collapse') {
			this.panels.forEach((p) => p.active = false);
			panel.active = !panel.active;
		}
	}

	/**
	 * Test
	 * - jQuery('.cv-collapsible-component cv-panel .cv-panel-header.action-toggle').click()
	 */
}
